<template>
  <div class="login-view container">
    <div class="login-logo">
      <img src="../assets/logo-colgate.svg" class="logo" />
    </div>

    <div class="login-content content">
      <h1>Login</h1>

      <form @submit.prevent="RealizaLogin()">
        <div class="form-group">
          <label for="exampleInputEmail1" class="form-label">E-mail</label>
          <input
            v-model="Email"
            placeholder="E-mail"
            type="text"
            class="form-control email"
            required />
        </div>

        <div class="form-group">
          <label class="form-label">Senha</label>
          <input
            v-model="Senha"
            placeholder="********"
            type="password"
            class="form-control password"
            required />
        </div>

        <button type="submit" class="btn btn-primary">Entrar</button>
      </form>
    </div>
  </div>
</template>

<script>
import { signIn, signOut } from "../services/auth"

export default {
  name: "Login",
  data() {
    return {
      Email: "Administrador",
      Senha: "4402@tudovis",
    }
  },
  methods: {
    RealizaLogin: async function () {
      var result = await signIn(this.Email, this.Senha)

      if (result.sucesso) 
      {
        this.$root.Usuario = result.data.usuario;
        this.$router.push("Home");
      } 
      else {
        alert(result?.mensagem ?? "Não foi possivel realizar o login")
      }
    },
  },
  mounted() {
    this.$root.Usuario = null;
  },
}
</script>

<style scoped>
body {
  width: 100%;
  min-height: 100vh;
}

.container {
  padding: 0 1.5rem;
}

.login-logo {
  width: 8.5rem;
  height: 6rem;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-color: #d2010d;
  margin: auto;
  padding: 1.5rem;
  border-radius: 0 0 24px 24px;
  box-shadow: 0px 4px 24px rgba(17, 18, 23, 0.25);
}

.logo {
  width: 7.5rem;
}

.login-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.25rem;
  margin-top: 6rem;
}

.login-content h1 {
  font-size: 2.25rem;
  letter-spacing: 1.25px;
  font-weight: 400;
  text-align: left;
  margin-bottom: 5rem;
}

form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.form-label {
  margin-bottom: 1rem;
  font-size: 1rem;
  line-height: 1;
  letter-spacing: 0.75px;
  color: var(--gray-200);
}

.form-control,
.form-control:focus {
  background-color: var(--gray-600);
  border: 1px solid rgba(83, 85, 95, 0.5);
  color: var(--gray-100);
}

.form-control {
  height: 3.5rem;
  padding: 0.5rem 1.5rem;
  border-radius: 0.75rem;
}

.email,
.password {
  background-position: center right 24px;
  background-repeat: no-repeat;
  background-size: 1.25rem;
  padding-right: 3.5rem;
}

.email {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24'%3E%3Cpath fill='none' d='M0 0h24v24H0z'/%3E%3Cpath d='M4 22a8 8 0 1 1 16 0h-2a6 6 0 1 0-12 0H4zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z' fill='rgba(83,85,95,1)'/%3E%3C/svg%3E");
}

.password {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24'%3E%3Cpath fill='none' d='M0 0h24v24H0z'/%3E%3Cpath d='M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0v1zM5 10v10h14V10H5zm6 4h2v2h-2v-2zm-4 0h2v2H7v-2zm8 0h2v2h-2v-2zm1-6V7a4 4 0 1 0-8 0v1h8z' fill='rgba(83,85,95,1)'/%3E%3C/svg%3E");
}

.btn-primary {
  margin-top: 1.5rem;
}

@media screen and (min-width: 990px) {
  body {
    border-top: 6px solid var(--gray-900);
  }

  .login-content {
    max-width: 500px;
    margin: 6rem auto 0;
    padding: 2.5rem 1.5rem;
    background-color: var(--gray-600);
    border-radius: 24px;
    box-shadow: 0 8px 12px rgba(22, 23, 30, 0.6);
  }
}

</style>
